const consultation = {
  state: {
    commuShowFlag: false,
    commuId: '1'
  },

  mutations: {
    SET_COMMUSHOWFLAG: (state, commuShowFlag) => {
      state.commuShowFlag = commuShowFlag
    },
    SET_COMMUID: (state, commuId) => {
      state.commuId = commuId
    }
  }
}

export default consultation



// WEBPACK FOOTER //
// ./src/store/modules/consultation.js